// extracted by mini-css-extract-plugin
export default {"row":"tvCGZEQTYnGLwGNhOMmD","question":"a5jArcqGrkog09CIpP72"};